import React, { Component } from "react";
import { connect } from "react-redux";

import * as actionTypes from "../../../../../store/actions";

//컴포넌트 바깥을 클릭했을 때에 대한 이벤트
class OutsideClick extends Component {
  //constructor() 객체를 만드는 역할을 하는 함수.
  //생성자는 객체에 대한 초기화(initialize)를 하여 불필요한 코드를 줄여 줄 수 있다.
  constructor(props) {
    //super()  부모클래스 생성자의 참조 ,  React.Component의 constructor를 가르킨다.
    // 자바스크립트는 언어적 제약사항으로서 이런 extends가 사용되었을 때 super를 호출하기 전에는 this를 호출 할 수 없다. (언어차원에서 this 를 사용하기 전에 강제 호출하는 것)
    //super()를 하지 않으면 Component의 this는 OutsideClick의 this라고 생각할 수 있음
    //super(props) Component도 역시 객체가 생성될 때 props 속성을 초기화하기 위해
    super(props);
    //bind() this가 bind에 제공된 값으로 설정된 새로운 함수를 생성
    this.setWrapperRef = this.setWrapperRef.bind(this);
    this.handleOutsideClick = this.handleOutsideClick.bind(this);

    //.bind() 새로운 함수를 생성
  }

  //.mousedown 클릭유지시 mousedown는 버튼을 처음 누르는 순간 시작됨
  componentDidMount() {
    document.addEventListener("mousedown", this.handleOutsideClick);
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleOutsideClick);
  }

  setWrapperRef(node) {
    this.wrapperRef = node;
  }

  /**
   * close menu if clicked on outside of element //특정 영역 외 클릭 시 발생하는 이벤트
   */
  handleOutsideClick(event) {
    // 해당 wrapperRef 이고 해당 wrapperRef에 이벤트가 발생한 대상 객체가 포함되어 있지않으면
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      //가로크기가 992미만이고 collapseMenu있으면
      if (this.props.windowWidth < 992 && this.props.collapseMenu) {
        // collapseMenu를 false로 상태 변경
        this.props.onToggleNavigation();
      }
    }
  }

  render() {
    return (
      //ref Dom을 직접적으로 건드려야 하기 때문에 사용하다
      <div className="nav-outside" ref={this.setWrapperRef}>
        {this.props.children}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    collapseMenu: state.collapseMenu,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onToggleNavigation: () => dispatch({ type: actionTypes.COLLAPSE_MENU }),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(OutsideClick);
